import OTPInput from "otp-input-react";
import React, { useState, useEffect } from "react";
import Loader from "../../../components/loader/loader";

import Snackbar from "../../../components/snackbar/snackbar";
import {
  userLogin,
  selectApplicationContext,
  switchAccount,
  getUserAccounts,
} from "../login/auth.api";
import jwtDecode from "jwt-decode";
import "../otp/otp.css";
export default function SwitchAccount(props) {
  const [OTP, setOTP] = useState("");
  const [submit, setSubmit] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [showSelection, setShowSelection] = useState(false);
  const [records, setRecords] = useState([]);
  const [tempToken, setTempToken] = useState("");
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (token) {
      // Extract phone from token for potential fallback/resend
      try {
        const decoded = jwtDecode(token);
        const mobile =
          decoded?.user?.mobile_number ||
          decoded?.mobile_number ||
          decoded?.sub;
        if (mobile && !props.phone) {
          props.setPhone(mobile);
        }
      } catch (e) {
        console.error("Token decode error", e);
      }

      setIsActive(true);
      // Automatically call getUserAccounts with current token to get records
      getUserAccounts(token)
        .then((res) => {
          setIsActive(false);
          console.log("getUserAccounts response:", res);
          // Handle new response structure
          if (res.success && res.data && res.data.accounts) {
            setRecords(res.data.accounts || []);
            setTempToken(res.temp_token || token);
            setShowSelection(true);
            if (res.data.user_info) {
              setUserInfo(res.data.user_info);
            }
          } else if (res.success && res.token) {
            completeLogin(res.token);
          }
        })
        .catch((err) => {
          setIsActive(false);
          console.log("getUserAccounts call failed, showing OTP screen", err);
        });
    } else {
      props.history.push("/dashboard");
    }
  }, []);

  const completeLogin = (token) => {
    sessionStorage.setItem("token", token);
    props.login(token);

    // Clear context on account switch to ensure fresh data
    localStorage.removeItem("context");

    props.history.push("/dashboard");
  };

  const handleVerify = (e) => {
    e.preventDefault();
    console.log("Verifying OTP for switch:", { phone: props.phone, otp: OTP });
    setSubmit(true);

    let data = {
      mobile_number: props.phone,
      otp_value: OTP,
    };
    setIsActive(true);
    switchAccount(data, sessionStorage.getItem("token"))
      .then((res) => {
        console.log("Switch account API response:", res);
        if (
          res.multiple_records_exist ||
          (res.success && res.data && res.data.accounts)
        ) {
          const accounts = res.data?.accounts || res.records || [];
          setRecords(accounts);
          setTempToken(res.temp_token || sessionStorage.getItem("token"));
          setShowSelection(true);
          if (res.data?.user_info) setUserInfo(res.data.user_info);
          setIsActive(false);
          setSubmit(false);
        } else {
          completeLogin(res.token);
        }
      })
      .catch((err) => {
        console.error("Switch account API error:", err);
        setSubmit(false);
        setIsActive(false);
        setSnackMessage(err.response?.data?.message || "Verification failed");
        setIsSnackError(true);
        setSnackOpen(true);
      });
  };

  const handleSelectApplication = (record) => {
    if (record.is_current) {
      props.history.push("/dashboard");
      return;
    }
    console.log("Selecting account:", record);
    setIsActive(true);
    const data = {
      application_id: record.type === "application" ? record.id : null,
      company_id: record.type === "company" ? record.id : null,
    };

    selectApplicationContext(data, tempToken)
      .then((res) => {
        console.log("Select application context response:", res);
        if (res.success) {
          if (res.context) {
            localStorage.setItem("context", JSON.stringify(res.context));
          }
          completeLogin(res.token);
        } else {
          setIsActive(false);
          setSnackMessage(res.message || "Failed to select application");
          setIsSnackError(true);
          setSnackOpen(true);
        }
      })
      .catch((err) => {
        console.error("Select application context error:", err);
        setIsActive(false);
        setSnackMessage(err.response?.data?.message || "Selection error");
        setIsSnackError(true);
        setSnackOpen(true);
      });
  };

  const resend = (e) => {
    e.preventDefault();
    let loginParam = { mobile_number: props.phone };
    setSubmit(true);
    setIsActive(true);

    userLogin(loginParam)
      .then((res) => {
        setSnackMessage(res.message);
        setSubmit(false);
        setIsActive(false);
        setIsSnackError(false);
        setSnackOpen(true);
      })
      .catch((err) => {
        setSubmit(false);
        setSnackMessage(err.response?.data?.message || "Failed to resend OTP");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };
  const getStatusLabel = (status) => {
    const labels = {
      0: "Draft",
      1: "Submitted",
      2: "Under Review",
      3: "Approved",
      4: "Rejected",
      7: "In Progress",
    };
    return labels[status] || "Active";
  };

  const RecordIcon = ({ record }) => {
    if (record.logo) {
      const servInstance = process.env.REACT_APP_BASE_URL;
      const result = servInstance.substring(0, servInstance?.length - 4);
      return (
        <div className="record-logo-wrapper">
          <img
            src={`${result}${record.logo}`}
            alt={record.company_name}
            onError={(e) => (e.target.style.display = "none")}
          />
        </div>
      );
    }

    const firstLetter = record.company_name?.charAt(0).toUpperCase() || "?";
    const colors = [
      "#3b82f6",
      "#10b981",
      "#f59e0b",
      "#ef4444",
      "#8b5cf6",
      "#ec4899",
    ];
    const colorIndex = firstLetter.charCodeAt(0) % colors.length;

    return (
      <div className="record-avatar" style={{ background: colors[colorIndex] }}>
        <span>{firstLetter}</span>
      </div>
    );
  };

  const getApplicationTypeIcon = (type) => {
    switch (type?.toLowerCase()) {
      case "kerala":
        return (
          <div className="type-icon-small kerala-bg">
            <svg
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
            </svg>
          </div>
        );
      case "india":
        return (
          <div className="type-icon-small india-bg">
            <svg
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10"></circle>
            </svg>
          </div>
        );
      default:
        return (
          <div className="type-icon-small generic-bg">
            <svg
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
            </svg>
          </div>
        );
    }
  };

  const snackbarClose = () => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    setOTP("");
  };

  return (
    <div className="otp-login-container">
     
      <div
        className={`otp-login-section ${showSelection ? "selection-active" : "selection-active"}`}
      >
        {!showSelection ? (
          <div className="">
               <Loader open={isActive} />
            </div>
        ) : (
          <div className="selection-body premium-selection">
            <div className="selection-header-premium">
              {userInfo && (
                <div className="welcome-badge">
                  WELCOME, {userInfo.name.toUpperCase()}
                </div>
              )}
              <h2>Switch Account</h2>
              <p>
                Please select the context you want to switch to. Your current
                active account is highlighted.
              </p>
            </div>
            <div className="records-grid-glass">
              {records.map((record, index) => (
                <div
                  key={index}
                  className={`glass-card animated-card ${record.is_current ? "current-record-glass" : ""}`}
                  onClick={() => handleSelectApplication(record)}
                >
                  <div className="glass-card-header">
                    <div className="glass-icon-wrapper">
                      <RecordIcon record={record} />
                      {getApplicationTypeIcon(record.type)}
                    </div>
                    <span
                      className={`glass-pill status-${record.application_status || (record.is_current ? 3 : 1)}`}
                    >
                      {record.is_current
                        ? "Active Now"
                        : getStatusLabel(record.application_status)}
                    </span>
                  </div>
                  <div className="glass-card-body">
                    <h3 className="company-name-glass">
                      {record.company_name}
                    </h3>
                    <div className="glass-ref-row">
                      <span className="glass-label">REF ID</span>
                      <span className="glass-value">
                        {record.unique_application_ref_no || `ID: ${record.id}`}
                      </span>
                    </div>
                  </div>
                  <div className="glass-card-footer">
                    <div className="glass-type-tag">{record.type}</div>
                    <div className="glass-action">
                      <span>{record.is_current ? "Continue" : "Switch"}</span>
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {records.length > 4 && (
              <div className="scroll-hint-glass">
                <span>Scroll for more accounts</span>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M7 13l5 5 5-5M7 6l5 5 5-5" />
                </svg>
              </div>
            )}
            <div className="selection-footer-premium">
              <button
                className="btn-back-minimal"
                onClick={() => props.history.push("/dashboard")}
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="19" y1="12" x2="5" y2="12"></line>
                  <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Return to Dashboard
              </button>
            </div>
          </div>
        )}
      </div>

      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
    </div>
  );
}
